
const initialState = {    
    clients: [],
    pageSize: 10,
    activePage: 1,    
    loadingClients: true,
    isSeacrhed: false,

    loadingMeansOfPayment: true,
    searchMeansOfPayment: {
        countryUuid: null
    },

    searchTerminal: {
        countryUuid: null
    },

    sortBy: {"name": "Name", "id": 0},
    in_VAT: true,
    activeOnly: "All",
    total_number: 0,
    sortDirection: 0,


    sortByUser: {"name": "Username", "id": 0},
    activeOnlyClient: "All",
    sortDirectionUser: 0,
    enabled: true, 
    activeOnlyUser: "All",
    total_numberUser: 0,
    activePageUser: 1,
    pageSizeUser: 10,
    searchUser: {
        searchFor: ""   
    },

    message: "Please run a search",
    search: {
        clientName: "",
        clientAddress: "",
        clientEmail: "",
        clientOIB: "",
        clientPhoneNumber: "",
        clientVAT: "",
        clientDomain: ""        
    },

    posProstorList: [],
    napUredajiList: [],
    articleList: [],
    usersList: [],
    operatorsList: [],
    meansOfPaymentList: [],
    taxRatesList:[],

    oneClient: [],
    oneClientCertificate: {},
    onePosPro: [],
    oneOperator: [],
    oneNapUred: [],
    oneArticle: [],
    oneUser: [],
    oneTaxRate: [],

   

    clientVisibleColumns:{
        "company_VAT_ID": false, 
		"company_address": false, 
		"company_legal_ID": false, 
		"company_name": false,
		"company_place": false,
		"company_postal_code": false,
		"email": false,
		"in_VAT": false,
		"login_domain": false,
		"phone_number": false,
		"provider": false
    },

    clientBusinessPremisesVisibleColumns:{
        "business_premises_address": false, 
		"business_premises_logo": false, 
		"business_premises_mark": false, 
		"business_premises_name": false,
		"business_premises_place": false,
		"business_premises_postal_code": false,
		"business_premises_remark": false,
		"business_premises_wh": false,
		"company_name": false,
		"country": false,
		"deleted": false
    },

    clientTerminalVisibleColumns:{
        "account_non_expired": false, 
        "account_non_locked": false, 
        "business_premises": false, 
        "created": false, 
        "credentials_non_expired": false, 
        "description": false, 
        "enabled": false, 
        "otp_is_valid": false, 
        "otp_valid_until": false, 
        "roles": false, 
        "tid": false    
    },

    clientOperatorsVisibleColumns:{
        "client": false, 
		"operator_mark": false, 
		"operator_name": false, 
		"operator_id": false,
		"operator_surname": false,
		"operator_username": false,
		"roles": false
    },

    clientUserVisibleColumns:{
        "client": false, 
        "account_non_expired": false, 
        "account_non_locked": false, 
        "credentials_non_expired": false, 
		"roles": false,
        "description": false, 
        "enabled": false,
        "email": false,
        "first_name": false,
        "last_name": false,
        "deleted": false,
        "username": false
    },

    clientMeansOfPaymentVisibleColumns: {
        "country": false,
        "display_name": false,
        "is_fiscalized": false,
        "Form.Label": false
    },

    clientTaxRateVisibleColumns:{
        "country": false,
        "deleted": false,
        "description": false,
        "Form.Label": false,
        "tax_rate": false
    }
};


const reducer = (state = initialState, action) => {
    const newState = { ...state };
    let item
    let searchParam
    switch (action.type) {


    case "MAP_IS_SEARCHED_CLIENT_LIST":
        return{
            ...state,
            isSeacrhed: action.data
        }
    
    case "MAP_CLIENT_USER_SORT_DIRECTION":
        return{
            ...state,
            sortDirectionUser: action.data
        }

    case "MAP_CLIENT_SORT_DIRECTION":
        return{
            ...state,
            sortDirection: action.data
        }
  
    case "MAP_CLIENT_USER_TOTAL_NUMBER":
        return{
            ...state,
            total_numberUser: action.data
        }
        
        
    case "MAP_CLIENT_TOTAL_NUMBER":
        return{
            ...state,
            total_number: action.data
        }
        
    case "MAP_CLIENT_USER_ACTIVE_ONLY":
        return{
            ...state,
            activeOnlyUser: action.data
        }

    case "MAP_CLIENT_ACTIVE_ONLY":
        return{
            ...state,
            activeOnly: action.data
        }
    
    case "CHANGE_ENABLED_CLIENT_PARAMETERS":
        return{
            ...state,
            enabled: action.data            
        }
      
    case "CHANGE_IN_VAT_CLIENT_PARAMETERS":
        return{
            ...state,
            in_VAT: action.data           
        }

    case "MAP_CLIENT_TAX_RATE_VISIBLE_COLUMN":
        return{
            ...state,
            clientTaxRateVisibleColumns: action.data            
        }

    case "TOGGLE_CLIENT_TAX_RATE_VISIBLE_COLUMN":
        item = action.data.dataField
        return{
            ...state,
            clientTaxRateVisibleColumns: {
                ...state.clientTaxRateVisibleColumns,
                [item]: !action.data.hidden
            }
        }

    case "MAP_CLIENT_MEANS_OF_PAYMENT_VISIBLE_COLUMN":
        return{
            ...state,
            clientMeansOfPaymentVisibleColumns: action.data            
        }

    case "TOGGLE_CLIENT_MEANS_OF_PAYMENT_VISIBLE_COLUMN":
        item = action.data.dataField
        return{
            ...state,
            clientMeansOfPaymentVisibleColumns: {
                ...state.clientMeansOfPaymentVisibleColumns,
                [item]: !action.data.hidden
            }
        }


    case "MAP_CLIENT_USERS_VISIBLE_COLUMN":
        return{
            ...state,
            clientUserVisibleColumns: action.data            
        }

    case "TOGGLE_CLIENT_USERS_VISIBLE_COLUMN":
        item = action.data.dataField
        return{
            ...state,
            clientUserVisibleColumns: {
                ...state.clientUserVisibleColumns,
                [item]: !action.data.hidden
            }
        }


    case "MAP_CLIENT_OPERATORS_VISIBLE_COLUMN":
        return{
            ...state,
            clientOperatorsVisibleColumns: action.data            
        }

    case "TOGGLE_CLIENT_OPERATORS_VISIBLE_COLUMN":
        item = action.data.dataField
        return{
            ...state,
            clientOperatorsVisibleColumns: {
                ...state.clientOperatorsVisibleColumns,
                [item]: !action.data.hidden
            }
        }

    case "MAP_CLIENT_TERMINAL_VISIBLE_COLUMN":
        return{
            ...state,
            clientTerminalVisibleColumns: action.data            
        }

    case "TOGGLE_CLIENT_TERMINAL_VISIBLE_COLUMN":
        const clientTerminal = action.data.dataField
        return{
            ...state,
            clientTerminalVisibleColumns: {
                ...state.clientTerminalVisibleColumns,
                [clientTerminal]: !action.data.hidden
            }
        }

    case "MAP_CLIENT_BUSINESS_PREMISES_VISIBLE_COLUMN":
        return{
            ...state,
            clientBusinessPremisesVisibleColumns: action.data            
        }

    case "TOGGLE_CLIENT_BUSINESS_PREMISES_VISIBLE_COLUMN":
        const clientBusinessPremises = action.data.dataField
        return{
            ...state,
            clientBusinessPremisesVisibleColumns: {
                ...state.clientBusinessPremisesVisibleColumns,
                [clientBusinessPremises]: !action.data.hidden
            }
        }

    case "MAP_CLIENT_VISIBLE_COLUMN":
        return{
            ...state,
            clientVisibleColumns: action.data
            
        }

    case "TOGGLE_CLIENT_VISIBLE_COLUMN":
        const clientColumn = action.data.dataField
        return{
            ...state,
            clientVisibleColumns: {
                ...state.clientVisibleColumns,
                [clientColumn]: !action.data.hidden
            }
        }

    case "MAP_ONE_USER":
        return{
            ...state,
            oneUser: action.data
        }  
            
    case "CHANGE_ONE_USER_DETAILS":
        const userKey = action.data.id
        return{
            ...state,
            oneUser: {
                ...state.oneUser,
                [userKey]: action.data.value
            }
        }

    case "MAP_USERS_LIST":
        return{
            ...state,
            usersList: action.data
        }

    case "CHANGE_SORTBY_CLIENT_PARAMETERS":
    return{
        ...state,
        sortBy: action.data
        
    }
    case "CHANGE_SORTBY_CLIENT_USER_PARAMETERS":
        return{
            ...state,
            sortByUser: action.data
            
        }
        
    case "CHANGE_SEARCH_CLIENT_PARAMETERS":
        searchParam = action.data.id
        return{
            ...state,
            search: {
                ...state.search,
                [searchParam]: action.data.value
            }
        }

    case "CHANGE_SEARCH_CLIENT_USER_PARAMETERS":
        searchParam = action.data.id
        return{
            ...state,
            searchUser: {
                ...state.search,
                [searchParam]: action.data.value
            }
        }

    case "CHANGE_SEARCH_MEANS_OF_PAYMENT_PARAMETERS":
        searchParam = action.data.id
        return{
            ...state,
            searchMeansOfPayment: {
                ...state.searchMeansOfPayment,
                [searchParam]: action.data.value
            }
        }

    case "CHANGE_SEARCH_TERMINAL_PARAMETERS":
        return{
            ...state,
            searchTerminal: {
                ...state.searchTerminal,
                countryUuid: action.data.value
            }
        }

    case "CHANGE_ONE_ARTICLE_DETAILS":
        const articleKey = action.data.id
        return{
            ...state,
            oneArticle: {
                ...state.oneArticle,
                [articleKey]: action.data.value
            }
        }
        
    case "MAP_ONE_ARTICLE":
        return{
            ...state,
            oneArticle: action.data
        }  
        
    case "CHANGE_ONE_TAX_RATE_DETAILS":
        item = action.data.id
        return{
            ...state,
            oneTaxRate: {
                ...state.oneTaxRate,
                [item]: action.data.value
            }
        }
        
    case "MAP_ONE_TAX_RATE":
        return{
            ...state,
            oneTaxRate: action.data
        }  

    case "CHANGE_ONE_NAPLATNI_UREDAJ_DETAILS":
        const napUredKey = action.data.id
        return{
            ...state,
            oneNapUred: {
                ...state.oneNapUred,
                [napUredKey]: action.data.value
            }
        }
   
    case "MAP_ONE_NAPLATNI_UREDAJ":
        return{
            ...state,
            oneNapUred: action.data
        }

    case "CHANGE_ONE_POSLOVNI_PROSTOR_DETAILS":
        const posProKey = action.data.id
        return{
            ...state,
            onePosPro: {
                ...state.onePosPro,
                [posProKey]: action.data.value
            }
        }

    case "MAP_ONE_POSLOVNI_PROSTOR":
        return{
            ...state,
            onePosPro: action.data
        }

    case "MAP_NAP_URED_LIST":
        return{
            ...state,
            napUredajiList: action.data
        }

    case "MAP_OPERATERI_LIST":
        return{
            ...state,
            operatorsList: action.data
        }

    case "MAP_ARTICLE_LIST":
        return{
            ...state,
            articleList: action.data
        }
    

    case "MAP_MEANS_OF_PAYMENT_LIST":
        return{
            ...state,
            meansOfPaymentList: action.data
        }

    case "MAP_TAX_RATES_LIST":
        return{
            ...state,
            taxRatesList: action.data
        }
    
    case "MAP_POS_PRO_LIST":
        return{
            ...state,
            posProstorList: action.data
        }

    case "MAP_ONE_CLIENT_CERTIFICATE_DETAILS":
        return{
            ...state,
            oneClientCertificate: action.data
        }

    case "MAP_ONE_CLIENT_DETAILS":
        return{
            ...state,
            oneClient: action.data
        }

   
       
    case "CHANGE_ONE_CLIENT_DETAILS":
        const key = action.data.id
        return{
            ...state,
            oneClient: {
                ...state.oneClient,
                [key]: (action.data.id === "inVatSystem" ?  !state.oneClient.inVatSystem : action.data.value )
            }
        }
       
    case "MAP_ONE_OPERATER_DETAILS":
        return{
            ...state,
            oneOperator: action.data
        }

    case "CHANGE_ONE_OPERATER_DETAILS":
        item = action.data.id
        return{
            ...state,
            oneOperator: {
                ...state.oneOperator,
                [item]:  action.data.value
            }
        }
    

    case "MAP_CLIENT_LIST_MESSAGE":
        return{
            ...state,
            message: action.data
        }

    case "MAP_CLIENT_LIST":
        return{
            ...state,
            clients: action.data       
        }

    case "MAP_LOADING_CLIENT":
        return{
            ...state,
            loadingClients: action.data        
        }
        case "MAP_LOADING_MEANS_OF_PAYMENT":
            return{
                ...state,
                loadingMeansOfPayment: action.data        
            }
        

    case "MAP_CLIENT_LIST_PAGE_SIZE":
        return{
            ...state,
            pageSize: action.data        
        }

    case "MAP_CLIENT_USER_LIST_PAGE_SIZE":
        return{
            ...state,
            pageSizeUser: action.data        
        }

    case "MAP_CLIENT_LIST_ACTIVE_PAGE":
        return{
            ...state,
            activePage: action.data        
        }

    case "MAP_CLIENT_USER_LIST_ACTIVE_PAGE":
        return{
            ...state,
            activePageUser: action.data        
        }

    default:
      // do ntohing
  }
  return newState;
};

export default reducer;
